import { render, staticRenderFns } from "./ChangeLanguage.vue?vue&type=template&id=374933e4&scoped=true"
import script from "./ChangeLanguage.vue?vue&type=script&lang=ts"
export * from "./ChangeLanguage.vue?vue&type=script&lang=ts"
import style0 from "./ChangeLanguage.vue?vue&type=style&index=0&id=374933e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374933e4",
  null
  
)

export default component.exports